import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/service/apiServices';
import * as $ from "jquery";
import { Global } from '../../../global';
import { Location } from '@angular/common';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../../../service/auth/auth.service'
import Swal from 'sweetalert2';
import { FileUploadService } from 'src/app/service/fileService';

@Component({
  selector: 'app-play-list',
  templateUrl: './play-list.component.html',
  styleUrls: ['./play-list.component.css']
})

export class PlayListComponent implements OnInit {

  playlistelecimento_id: any = 0;
  listaBloco: any = [];
  listaClinica: any = [];
  playlist: any = {};
  uid: any = null;
  loading: any = false;

  videos: any = [];
  videoUploadTemp: string | null = null; // nome do vídeo aguardando salvar

  constructor(
    private route: ActivatedRoute,
    public service: ApiService,
    private router: Router,
    private global: Global,
    private location: Location,
    private authService: AuthService,
    private fileUploadService: FileUploadService,
  ) { }

  goBack() {
    this.location.back();
  }
  ngOnInit() {
    Swal.fire('Favor aguarde');
    Swal.showLoading();
    const uid = this.route.snapshot.paramMap.get('uuid');
    this.uid = uid;
    if (this.uid) {
      this.obterPlayList(this.uid);
      this.obterVideosPlayList(this.uid);
    } else {
      Swal.close();
    }
  }

  obterPlayList(id) {
    this.service.Get(`Playlist/${id}`).then(res => {
      Swal.close();
      this.loading = false;
      this.playlist = res;
    }).catch(res => {
      if (res.status == 401 || res.error.status == 401) {
        Swal.close()
        this.authService.logoutUser()
      }
      Swal.close();
      this.loading = false;
      Swal.fire('Erro', `${res.error.erros[0].messagem}`, 'error');
    });
  }

  obterVideosPlayList(id) {
    this.service.Get(`Playlist/${id}/ArquivoMidia`).then(res => {
      Swal.close();
      this.loading = false;
      this.videos = res['conteudo'];
    }).catch(res => {
      if (res.status == 401 || res.error.status == 401) {
        Swal.close()
        this.authService.logoutUser()
      }
      Swal.close();
      this.loading = false;
      Swal.fire('Erro', `${res.error.erros[0].messagem}`, 'error');
    });
  }

  salvar(item: any) {
    if (!item.nome) {
      Swal.fire('Atenção', `O nome da playlist é obrigatório`, 'warning');
      return
    }


    var obj = {
      "nome": item.nome,
      "ativo": item.ativo
    }
    this.loading = true;
    Swal.fire('Favor aguarde');
    Swal.showLoading();
    if (this.playlist.id) {
      this.service.Put(`Playlist/${this.playlist.id}`, obj).then(res => {
        Swal.close();
        this.loading = false;
        this.playlist = res;
      }).catch(res => {
        if (res.status == 401 || res.error.status == 401) {
          Swal.close()
          this.authService.logoutUser()
        }
        Swal.close();
        this.loading = false;
        Swal.fire('Erro', `${res.error.erros[0].messagem}`, 'error');
      });
    } else {
      this.service.Post(`Playlist`, obj).then(res => {
        Swal.close();
        this.loading = false;
        this.playlist = res;
      }).catch(res => {
        if (res.status == 401 || res.error.status == 401) {
          Swal.close()
          this.authService.logoutUser()
        }
        Swal.close();
        this.loading = false;
        Swal.fire('Erro', `${res.error.erros[0].messagem}`, 'error');
      });
    }
  }

  onVideoSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (!input.files || input.files.length === 0) return;
    const file = input.files[0]; // apenas um arquivo
    this.loading = true;
    Swal.fire('Favor aguarde');
    Swal.showLoading();
    this.fileUploadService.pushFileToStorage(`Arquivo/PlayList/${this.playlist.codigo}`, file).then(
      (result: any) => {
        Swal.close();
        if (result["ok"] == false) {
          this.videoUploadTemp = result["error"].text;
        }
        this.loading = false;
      },
      err => {
        Swal.close();
        this.loading = false;
        if (err.status == 401) {
          return;
        }
      }
    );
    input.value = '';
  }


  enviarVideoParaPlaylist(): void {
    if (!this.videoUploadTemp || !this.playlist.id) return;

    const obj = {
      ativo: true,
      nome: this.videoUploadTemp,
      nome_arquivo: this.videoUploadTemp,
      ordem: this.videos.length // ou outro critério
    };

    this.loading = true;
    Swal.fire('Favor aguarde');
    Swal.showLoading();
    this.service.Post(`Playlist/${this.playlist.id}/ArquivoMidia`, obj).then(res => {
      Swal.close();
      this.videoUploadTemp = null;
      this.loading = false;
      this.obterVideosPlayList(this.playlist.id); // Atualiza a lista de vídeos
      Swal.fire('Sucesso', 'Vídeo adicionado à playlist.', 'success');
    }).catch(err => {
      Swal.close();
      this.loading = false;
      Swal.fire('Erro', 'Erro ao salvar vídeo.', 'error');
    });
  }

  removerVideo(item: any, ativo: any): void {
    Swal.fire({
      title: 'Atenção',
      text: `Tem certeza que deseja ${ativo ? "ativar" : "desativar"} esse video?`,
      icon: 'warning',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      cancelButtonColor: '#dc3545'
    }).then(
      result => {
        if (result.isConfirmed) {
          Swal.fire('Favor aguarde');
          Swal.showLoading();
          this.service.AtivarDesativar(`ArquivoMidia/${item.id}/Ativar`, ativo).then((res) => {
            Swal.close();
            Swal.fire({
              icon: 'success',
              title: 'Sucesso!',
              html: 'Operação realizada com sucesso!'
            }).then(
              result => {
                if (result.isConfirmed) {
                  this.obterVideosPlayList(this.playlist.id);
                }
              }
            );
          }).catch((err) => {
            if (err.status == 401 || err.error.status == 401) {
              Swal.close()
              this.authService.logoutUser()
            }
            Swal.close();
            Swal.fire({
              icon: 'error',
              title: 'Erro',
              html: err.error.erros[0].messagem
            });
          })
        }
      }
    );
  }

  moverVideo(index: number, direcao: number): void {
    const novaPosicao = index + direcao;
    if (novaPosicao < 0 || novaPosicao >= this.videos.length) return;

    // Troca as posições
    [this.videos[index], this.videos[novaPosicao]] = [this.videos[novaPosicao], this.videos[index]];

    // Atualiza a ordem dos itens no array
    this.videos.forEach((video, i) => video.ordem = i);

    // Atualiza os dois vídeos envolvidos na troca
    const video1 = this.videos[index];
    const video2 = this.videos[novaPosicao];

    this.atualizarVideoOrdem(video1);
    this.atualizarVideoOrdem(video2);
  }

  atualizarVideoOrdem(video: any): void {
    const body = {
      ativo: video.ativo,
      nome: video.nome,
      nome_arquivo: video.nome_arquivo,
      ordem: video.ordem
    };

    this.service.Put(`ArquivoMidia/${video.id}`, body).then((res) => {
      Swal.close();
      this.obterVideosPlayList(this.playlist.id);
    }).catch((err) => {
      if (err.status == 401 || err.error.status == 401) {
        Swal.close()
        this.authService.logoutUser()
      }
      Swal.close();
      Swal.fire({
        icon: 'error',
        title: 'Erro',
        html: err.error.erros[0].messagem
      });
    })
  }

}

